<div class="chatbot-container">

    <!-- Ventana del chat: se abre hacia arriba, anclada al botón -->
    <div class="chat-window" [class.open]="isOpen" role="dialog" aria-label="Asistente virtual">
        <div class="chat-header">
            <img src="assets/images/logo-128.webp" class="avatar" alt="" aria-hidden="true">
            <div class="title">
                <h3>Asistente virtual</h3>
                <p>{{ isConfigured ? 'En línea' : 'Muy pronto disponible' }}</p>
            </div>
            <button class="close-btn" (click)="toggleChat()" aria-label="Cerrar chat">✖</button>
        </div>

        <div class="chat-messages" #messagesArea>
            <div *ngFor="let msg of messages" class="message" [ngClass]="msg.sender">
                <p>{{ msg.text }}</p>
            </div>

            <div *ngIf="isLoading" class="message bot typing" aria-label="Escribiendo">
                <span></span><span></span><span></span>
            </div>
        </div>

        <div class="chat-input">
            <input type="text" placeholder="Escribe un mensaje..." aria-label="Mensaje"
                [(ngModel)]="userMessage" (keyup.enter)="sendMessage()" maxlength="500" />
            <button class="send-btn" (click)="sendMessage()" aria-label="Enviar mensaje"
                [disabled]="isLoading || !userMessage.trim()">➤</button>
        </div>
    </div>

    <!-- Botón flotante -->
    <button class="chat-toggle-btn" [class.is-open]="isOpen" (click)="toggleChat()"
        [attr.title]="isOpen ? 'Cerrar el asistente' : 'Hablar con el asistente'"
        [attr.aria-label]="isOpen ? 'Cerrar el asistente' : 'Hablar con el asistente'"
        [attr.aria-expanded]="isOpen">

        <svg *ngIf="!isOpen" class="chat-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M12 3.2c-5.08 0-9.2 3.6-9.2 8.05 0 2.36 1.16 4.48 3 5.94-.13 1.16-.62 2.2-1.45 3.06-.24.25-.06.66.29.62 1.93-.2 3.57-.9 4.8-1.85.81.2 1.67.3 2.56.3 5.08 0 9.2-3.6 9.2-8.07S17.08 3.2 12 3.2z" />
            <circle class="chat-icon-dot" cx="8.4" cy="11.2" r="1.15" />
            <circle class="chat-icon-dot" cx="12" cy="11.2" r="1.15" />
            <circle class="chat-icon-dot" cx="15.6" cy="11.2" r="1.15" />
        </svg>

        <svg *ngIf="isOpen" class="chat-toggle-icon chat-toggle-icon--close" viewBox="0 0 24 24"
            aria-hidden="true">
            <path d="M6.4 6.4l11.2 11.2M17.6 6.4L6.4 17.6" />
        </svg>
    </button>
</div>
